import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 ESCALA NPS — 0 a 10

    El estándar de "qué tan probable es que nos recomiendes". Los
    colores siguen la clasificación real: 0-6 detractores, 7-8 pasivos,
    9-10 promotores. Eso ayuda a que el usuario entienda la escala.
*/

const onGetTone = (n) => {
    if (n <= 6) return 'danger';
    if (n <= 8) return 'warning';
    return 'ok';
};

export const FieldNps = ({
    id, name, label, hint, error,
    value = null, onChange,
    minLabel = 'Nada probable', maxLabel = 'Muy probable',
    isDisabled = false, span = 2,
}) => (

    <FieldShell label={label} hint={hint} error={error}
        isDisabled={isDisabled} span={span} >

        <div className={`${BLOCK}__nps`} role="radiogroup">
            {
                Array.from({ length: 11 }, (_, n) => (
                    <button key={n} type="button"
                        className={`${BLOCK}__nps_button`}
                        data-tone={onGetTone(n)} data-on={value === n}
                        role="radio" aria-checked={value === n} disabled={isDisabled}
                        onClick={() => onChange?.({ target: { name: name ?? id, value: n } })} >
                        {n}
                    </button>
                ))
            }
        </div>

        <div className={`${BLOCK}__nps_legend`}>
            <span>{minLabel}</span>
            <span>{maxLabel}</span>
        </div>

    </FieldShell>
);
